





import { linkedIn, linkedInLiteral } from '@/data';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LinkedInIcon extends Vue {
  @Prop(Boolean) public large!: boolean;

  public linkedIn: string = linkedIn;
}
